export enum BotDifficulty {
    BotEasy = 0,
    BotMedium = 1
}
